import { render, staticRenderFns } from "./UploadDocumentModal.vue?vue&type=template&id=cef55630&"
import script from "./UploadDocumentModal.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cef55630')) {
      api.createRecord('cef55630', component.options)
    } else {
      api.reload('cef55630', component.options)
    }
    module.hot.accept("./UploadDocumentModal.vue?vue&type=template&id=cef55630&", function () {
      api.rerender('cef55630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/UploadDocumentModal.vue"
export default component.exports